import { isLogScale } from '../../../core/utils/detect-scale.js';
import { sanitizeZeroValues } from '../../../core/utils/sanitize-zero-values.js';
import { safeGet } from '../../providers/HistogramDataProvider.js';
import {
  HistogramBin,
  WeakMapBins,
  XScale,
  YScale,
} from '../../types/histogram.js';

export function width(xScale: XScale, binsMap: WeakMapBins) {
  return (bin: HistogramBin) =>
    Math.abs(
      xScale(safeGet(binsMap, bin).to) - xScale(safeGet(binsMap, bin).from),
    );
}

export function height(scale: YScale, binsMap: WeakMapBins) {
  return (bin: HistogramBin) => {
    const { value, cumulativeValue = 0 } = safeGet(binsMap, bin);
    const isLogValue = isLogScale(scale) && cumulativeValue !== value;

    if (isLogValue) {
      const baseCumulative = sanitizeZeroValues(scale, cumulativeValue - value);
      const cumulativeCoordinate = sanitizeZeroValues(scale, cumulativeValue);

      return baseCumulative - cumulativeCoordinate;
    }
    const valueCoordinate = sanitizeZeroValues(scale, value);
    const zeroCoordinate = sanitizeZeroValues(scale, 0);

    return zeroCoordinate - valueCoordinate;
  };
}

export function x(xScale: XScale, binsMap: WeakMapBins) {
  return (bin: HistogramBin) => xScale(safeGet(binsMap, bin).from);
}

export function y(yScale: YScale, binsMap: WeakMapBins) {
  return (bin: HistogramBin) => {
    const c = yScale(safeGet(binsMap, bin).cumulativeValue ?? 0);
    const max = yScale.invert(0);

    return yScale(max) + c;
  };
}
